import { Component, ElementRef, OnInit, Renderer2, signal, ViewChild } from '@angular/core';
import { NemaService } from '../../Services/nema.service';
import { SharedDataService } from '../../Services/SharedServices/shared-data.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PdfDialogComponent } from '../pdf-dialog/pdf-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ImageDialogComponent } from '../HPDropDownChangeImage/image-dialog/image-dialog.component';
import { HPMountingPosComponent } from '../HPDropDownChangeImage/hpmounting-pos/hpmounting-pos.component';
import { FandialogComponent } from '../HPDropDownChangeImage/fandialog/fandialog.component';
import { environment } from '../../../Environment/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-fourth-selection',
  templateUrl: './fourth-selection.component.html',
  styleUrl: './fourth-selection.component.css'
})
export class FourthSelectionComponent implements OnInit{
  signalStatus:boolean=false;
  panelOpenState = signal(this.signalStatus);
  @ViewChild('inputHandAssemblyDropDown') inputHandAssemblyDropDown!: ElementRef<HTMLSelectElement>;
  @ViewChild('inputMountingPositionDropDown') inputMountingPositionDropDown!: ElementRef<HTMLSelectElement>;
  @ViewChild('inputCoolingFanDropDown') inputCoolingFanDropDown!: ElementRef<HTMLSelectElement>;
  Size:any;
  Ratio:any;
  InputSpeed:any;
  public inputGearOrientation:any;
  public inputShaftType:any;
  public inputBoreDia:any;
  public inputHandAssembly:any;
  public inputMountingPosition:any;
  public inputMotorAdaptor:any;
  public inputMotorFrameSize:any;
  public sortedInputMotorFrameSize:any[] = [];
  public gearOrientationSelection: any;
  public shaftTypeSelection:any;
  public assemblySelection:any;
  public inputCoolingFan:any[]=[];
  dutyCycle:any;
  hpnoStatus:any;
  Series:any;
  setStatus="";
  formSubmitted = false;
  public reducerSelectionForm!: FormGroup;
  AssetbasePath:any;
    public showspinfo: boolean = false;
  public showcdinfo: boolean = false;
  constructor(public dialog: MatDialog,private formBuilder:FormBuilder,private service:NemaService,private sharedDataService: SharedDataService,private renderer: Renderer2,private elementRef: ElementRef,private router: Router) {
    this.AssetbasePath = environment.assetsPath;
  }
ngOnInit():void{
  const currentUrl = window.location.href.toLowerCase();
  if (currentUrl.includes('spineatools') ) {
      this.showspinfo = true;
      this.showcdinfo = false;
    } else {
      this.showspinfo = false;
      this.showcdinfo = true;
    }
this.sharedDataService.getFormData().subscribe(data => {
  
  this.dutyCycle = data.selectedDutyCycle;
});
this.sharedDataService.getSeriesData().subscribe(data => {
  this.Series = data;
  console.log("MY SERIESSSSSSSS IS FROM HP", data);
  
});
  this.sharedDataService.SizeReducerFeatureData$.subscribe((SizeData:any) => 
  {
    this.Size = SizeData.SizeReducerFeatureData
    this.InputSpeed =SizeData.inputSpeed
    this.Ratio = SizeData.ratio
    this.configurationData.Size = SizeData.SizeReducerFeatureData
    this.configurationData.Ratio = SizeData.ratio
    this.configurationData.InputSpeed = SizeData.inputSpeed
    this.getGearOrientation(this.Size);
    this.ImgageData.GearOrientationImage = SizeData.imageUrl;
    console.log("Size from step 4 size data"+JSON.stringify(SizeData, null, 2));
  });
  this.init();
  
}
private init():void{
  this.reducerSelectionForm = this.formBuilder.group({
    inputGearOrientation:[null, Validators.required],
    inputShaftType:[null, Validators.required],
    inputBoreDia:[{ value: null, disabled: false }, Validators.required],
    inputMotorAdaptor:[null, Validators.required],
    inputMotorFrameSize:[{ value: null, disabled: false }, Validators.required],
  });
}
private getGearOrientation(size:any):void{
  this.signalStatus=true;
  this.panelOpenState = signal(this.signalStatus);
  this.service.getGearOrientation(size).subscribe(result=>{
    this.inputGearOrientation = result;
  },
  (error) => {
    console.error('Error fetching in gear orientation :', error);
  })
}

private getShaftType(size:any):void{
 
  this.service.getShaftType(size).subscribe(result=>{
    this.inputShaftType = result;
  },
  (error) => {
    console.error('Error fetching in shaft type :', error);
  })
}

private getBoreDia(size:any):void{
 
  this.service.getBoreDia(size).subscribe(result=>{
    this.inputBoreDia = result;
  },
  (error) => {
    console.error('Error fetching in bore diameter :', error);
  })
}


private getHandAssembly(shaftType:any,gearOrientation:any,size:any):void{
 
  this.service.getHandAssembly(shaftType,gearOrientation,size).subscribe(result=>{
    // console.log("Result in Reducer: "+result);
    this.inputHandAssembly = result;
  },
  (error) => {
    console.error('Error fetching in bore diameter :', error);
  })
}


private getMountPosition(shaftType:any,gearOrientation:any,size:any,assembly:any):void{
 
  this.service.getMountPosition(shaftType,gearOrientation,size,assembly).subscribe(result=>{
    console.log("Mouniting Position: "+result);
    this.inputMountingPosition = result;
  },
  (error) => {
    console.error('Error fetching in bore diameter :', error);
  })
}
private getCoolingFan(assembly:any,shaftType:any,gearOrientation:any,size:any):void{
 
  this.service.getCoolingFan(assembly,shaftType,gearOrientation,size).subscribe(result=>{
    console.log(result);
    result.forEach((element: { inputType: any; inputTypeDesc:any; outputTypeDesc:any; }) => {
      // this.inputCoolingFan.push(element.inputType);
      this.configurationData.inputType = element.inputType;
      this.configurationData.InputTypeDesc = element.inputTypeDesc;
      this.configurationData.OutputTypeDesc = element.outputTypeDesc;
    });
    // this.inputCoolingFan = result;
    console.log(this.configurationData);
  },
  (error) => {
    console.error('Error fetching in bore diameter :', error);
  })
}
private getMotorAdaptor():void{
 
  this.service.getMotorAdaptor().subscribe(result=>{
    // console.log("Result in Reducer: "+result);
    this.inputMotorAdaptor = result;
  },
  (error) => {
    console.error('Error fetching in Motor adaptor :', error);
  })
}
private getFan():void{
  
  if(this.configurationData.inputType=="SE"){
    this.inputCoolingFan.push("Fan on input shaft");
  }else if(this.configurationData.inputType=="DE"){
    this.inputCoolingFan.push("Fan on input shaft");
    this.inputCoolingFan.push("Fan opposite input on double extended shaft");
    this.inputCoolingFan.push("Fan opposite input, no extension");
  } else if(this.configurationData.inputType=="SA"){
    this.inputCoolingFan.push("Fan opposite input on double extended shaft");
    this.inputCoolingFan.push("Fan opposite input, no extension");
  }else if(this.configurationData.inputType=="DA"){
    this.inputCoolingFan.push("Fan opposite input on double extended shaft");
    this.inputCoolingFan.push("Fan opposite input, no extension");
  }
}


private getMotorFrameSize(size:any):void{
 
  this.service.getMotorFrameSize(size).subscribe(result=>{
    this.inputMotorFrameSize = result;
    this.sortedInputMotorFrameSize = [...(result || [])].sort((a: any, b: any) =>
      (a?.motorFrame || '').toString().localeCompare((b?.motorFrame || '').toString(), undefined, {
        numeric: true,
        sensitivity: 'base'
      })
    );
  },
  (error) => {
    console.error('Error fetching in motor frame :', error);
  })
}

onGearOrientationChange(event: any) {
  debugger;
  const selectedValue = event.target.value;
  this.gearOrientationSelection = selectedValue;
  if(selectedValue == "WormOverGear"){
    this.configurationData.GearOrientation = "HO";
  }else if(selectedValue == "WormUnderGear"){
    this.configurationData.GearOrientation = "HU";
  }else{
    this.configurationData.GearOrientation = "HV";
  }
  this.resetDependentDropdowns(['inputShaftType']);
  this.getShaftType(this.Size);
}
onShaftTypeChange(event:any){
  debugger;
  const selectedValue = event.target.value;
  this.shaftTypeSelection = selectedValue;
  if(selectedValue=="HollowOutputBore"){
    this.configurationData.ShaftType = "HollowOutputBore";
    const boreDiaTypeRow = document.getElementById("inputBoreDia") as HTMLInputElement
    if(boreDiaTypeRow.disabled == true){
      this.reducerSelectionForm.get('inputBoreDia')?.enable();
  
  this.reducerSelectionForm.get('inputBoreDia')?.updateValueAndValidity();
    }
    

    this.getBoreDia(this.Size);
  }else{
    this.configurationData.ShaftType = "SolidOutputBore";
    const boreDiaTypeRow = document.getElementById("inputBoreDia") as HTMLInputElement
    this.reducerSelectionForm.get('inputBoreDia')?.disable();
    boreDiaTypeRow.value='';
    this.getHandAssembly(this.shaftTypeSelection,this.gearOrientationSelection,this.Size);
    this.configurationData.BoreDia = "";
    
    this.onDropdownClick();
  }
  this.resetDependentDropdowns(['inputBoreDia']);
}
oninputBoreDiaChange(event:any){
  debugger;
  this.getHandAssembly(this.shaftTypeSelection,this.gearOrientationSelection,this.Size);
  this.configurationData.BoreDia = event.target.value;
  this.resetDependentDropdowns(['inputHandAssembly']);
  this.onDropdownClick();
}
oninputHandAssemblyChange(event:any){
  const selectedValue = event.target.value;
  this.assemblySelection = selectedValue;
  this.getMountPosition(this.shaftTypeSelection,this.gearOrientationSelection,this.Size,this.assemblySelection);
  // if(this.dutyCycle=="yes"){
    this.getCoolingFan(this.assemblySelection,this.shaftTypeSelection,this.gearOrientationSelection,this.Size);
  // }
  
  this.resetDependentDropdowns(['inputMountingPosition']);
}
oninputMountingPositionChange(event:any){
 debugger;
  if(this.Size<120){
    // if(this.Size<70){
    const motorAdaptor = document.getElementById("inputMotorAdaptor") as HTMLInputElement
    if(motorAdaptor.disabled == true){
      motorAdaptor.disabled = false;
      this.reducerSelectionForm.get('inputMotorAdaptor')?.enable();
      this.reducerSelectionForm.get('inputMotorAdaptor')?.updateValueAndValidity();
    }
    this.configurationData.MountingPosition = event.target.value;
    this.configurationData.MountingPositionText = event.target.selectedOptions[0].innerText;
    this.getMotorAdaptor();
  }else{
    const motorAdaptor = document.getElementById("inputMotorAdaptor") as HTMLInputElement
    const motorFrameSize = document.getElementById("inputMotorFrameSize") as HTMLInputElement
    this.configurationData.MountingPosition = event.target.value;
    this.configurationData.MountingPositionText = event.target.selectedOptions[0].innerText;
    this.configurationData.MotorAdaptor = "N";
    this.reducerSelectionForm.get('inputCoolingFan')?.enable();
    motorAdaptor.disabled = true;
    motorFrameSize.disabled = true;
    motorAdaptor.value='';
    motorFrameSize.value='';
  }
  this.resetDependentDropdowns(['inputMotorAdaptor']);
}
oninputMotorAdaptorChange(event:any){
 debugger;
  const selectedValue = event.target.value;
  const coolingFan = document.getElementById("inputCoolingFan") as HTMLInputElement
  if(selectedValue == "yes"){
    
    const motorFrameSize = document.getElementById("inputMotorFrameSize") as HTMLInputElement
    
        if(motorFrameSize.disabled == true){
          this.reducerSelectionForm.get('inputMotorFrameSize')?.enable();
          this.reducerSelectionForm.get('inputMotorFrameSize')?.updateValueAndValidity();
        }
        this.configurationData.MotorAdaptor = selectedValue;
        this.getMotorFrameSize(this.Size)
        if(this.configurationData.inputType=="SE"){
          this.configurationData.inputType = "SA";
        }else if(this.configurationData.inputType=="DE"){
          this.configurationData.inputType="DA";
        }
    // this.reducerSelectionForm.get('inputCoolingFan')?.disable();
  
  }else{
   debugger;
    
    const motorFrameSize = document.getElementById("inputMotorFrameSize") as HTMLInputElement
    this.reducerSelectionForm.get('inputMotorFrameSize')?.disable();
    motorFrameSize.value='';
    this.configurationData.MotorAdaptor = "N";
    console.log(this.configurationData);
    if(this.configurationData.inputType=="SA"){
      this.configurationData.inputType = "SE";
    }else if(this.configurationData.inputType=="DA"){
      this.configurationData.inputType="DE";
    }
    let arrMatch = [15,20,25,120];
    if(arrMatch.includes(parseInt(this.Size))){
      if(coolingFan){
        coolingFan.disabled = true;
      }
      // coolingFan.disabled = true;
    }else{
      if(coolingFan.disabled == true){
        coolingFan.disabled = false;
      }
      this.getFan();
    }
  }
  this.resetDependentDropdowns(['inputMotorFrameSize']);
}
oninputCoolingFanChange(event:any){
  debugger;
  const selectedValue = event.target.value;
  this.configurationData.coolingType=selectedValue;
}
oninputMotorFrameSizeChange(event:any){
 
  const coolingFan = document.getElementById("inputCoolingFan") as HTMLInputElement
  const selectedValue = event.target.value;
  if(selectedValue=="48C"){
    this.configurationData.MotorAdaptor = "A";
  }else if(selectedValue == "56C"){
    this.configurationData.MotorAdaptor = "B";
  }else if(selectedValue == "143TC/145TC"){
    this.configurationData.MotorAdaptor = "C";
  }else if(selectedValue == "182TC/184TC"){
    this.configurationData.MotorAdaptor = "D";
  }else if(selectedValue == "213TC/215TC"){
    this.configurationData.MotorAdaptor = "E";
  }else if(selectedValue == "254TC/256TC"){
    this.configurationData.MotorAdaptor = "F";
  }else if(selectedValue == "284TC/286TC"){
    this.configurationData.MotorAdaptor = "G";
  }else{
    this.configurationData.MotorAdaptor = "N";
  }
  console.log(this.configurationData);
  this.inputCoolingFan=[];
  let arr=[15,20,25,120];
  if(arr.includes(parseInt(this.Size))){
    coolingFan.disabled = true
  }else{
    if(coolingFan.disabled == true){
      coolingFan.disabled = false;
    }
    this.getFan();
  }
  this.resetDependentDropdowns(['inputCoolingFan']);
}
reducerButton():void{
  this.formSubmitted = true;
    if (this.reducerSelectionForm.valid) {
      this.sharedDataService.setConfigurationNumber(this.configurationData);
      this.sharedDataService.setCADChangeStatus("true");
    }else{
      // console.log("All the data is not filled yet");
    }
}
configurationData={
  GearOrientation:"",
  Size:"",
  ShaftType:"",
  MountingPosition:"",
  ShaftCode:"",
  MotorAdaptor:"",
  FanCooling:"f",
  InputSpeed:"",
  Ratio:"",
  BoreDia:"",
  inputType:"",
  coolingType:"",
  InputTypeDesc:"",
  OutputTypeDesc:"",
  MountingPositionText:"",
  Assembly:"",
  series:""
}
private resetDependentDropdowns(dropdownNames: string[]) {
  dropdownNames.forEach(name => {
    this.reducerSelectionForm.get(name)?.reset();
  });
}
ImgageData={
  GearOrientationImage:"",
};



viewPDF(pdfSrc: string) {
  debugger;
  pdfSrc = this.AssetbasePath+"/Content/BImages/MountingPositionpdf.pdf";
  this.dialog.open(PdfDialogComponent, {
    data: { pdfSrc: pdfSrc }
  });
}









onDropdownClick() {
  this.openImageDialog();
}


// Method to open the image selection dialog
openImageDialog() {
  const dialogRef = this.dialog.open(ImageDialogComponent, {
  });

    if(this.configurationData.ShaftType == "SolidOutputBore"){
      debugger;
      if(this.configurationData.GearOrientation =="HO"){
        if(this.Size=="15"){
          this.displayElement("15_HO_Solid");
        }else if((this.Size == "20")||(this.Size == "25")){
          this.displayElement("20_25_HO_Solid");
        }else{
          this.displayElement("30_120_HO_Solid");
        }
      }else if(this.configurationData.GearOrientation =="HU"){
        if(this.Size=="15"){
          this.displayElement("15_HU_Solid");
        }else if((this.Size == "20")||(this.Size == "25")){
          this.displayElement("20_25_HU_Solid");
        }else{
          this.displayElement("30_120_HU_Solid");
        }
      }else if(this.configurationData.GearOrientation =="HV"){
        if((this.Size == "20")||(this.Size == "25")){
          this.displayElement("20_25_HV_Solid");
        }else{
          this.displayElement("30_120_HV_Solid");
        }
      }
    }else if(this.configurationData.ShaftType == "HollowOutputBore"){
      if(this.configurationData.GearOrientation =="HO"){
        
        if((this.Size == "100")||(this.Size == "120")){
          this.displayElement("100_120_HO_Hollow");
        }else if((this.Size == "20")||(this.Size == "25")){
          this.displayElement("20_25_HO_Hollow");
        }else{
          this.displayElement("30_120_HO_Hollow");
        }
      }else if(this.configurationData.GearOrientation =="HU"){
        if((this.Size == "100")||(this.Size == "120")){
          this.displayElement("100_120_HU_Hollow");
        }else if((this.Size == "20")||(this.Size == "25")){
          this.displayElement("20_25_HU_Hollow");
        }else{
          this.displayElement("30_120_HU_Hollow");
        }
      }else if(this.configurationData.GearOrientation =="HV"){
        if((this.Size == "100")||(this.Size == "120")){
          this.displayElement("100_120_HV_Hollow");
        }else if((this.Size == "20")||(this.Size == "25")){
          this.displayElement("20_25_HV_Hollow");
        }else{
          this.displayElement("30_120_HV_Hollow");
        }
      }
    }
    
    


  dialogRef.afterClosed().subscribe((selectedImage) => {
    var data=0;
    if (selectedImage) {
      const imgData = document.getElementById('inputHandAssembly') as HTMLInputElement;
      const dropdown = this.inputHandAssemblyDropDown.nativeElement;
      if (imgData) {
        const targetValue = selectedImage; // The value you want to select
      debugger;
        for (let i = 0; i < dropdown.options.length; i++) {
          if (dropdown.options[i].text === targetValue) {
          this.configurationData.Assembly = dropdown.options[i].value;
            dropdown.selectedIndex = i;
            data=i; // Set the dropdown's selected index to the matching option
            break; // Stop the loop once the match is found
          }
        }
      }

const dropdown1 = this.inputHandAssemblyDropDown.nativeElement;

const selectedOption = dropdown1.options[dropdown1.selectedIndex] as HTMLOptionElement;

if (selectedOption) {
  debugger;
  this.assemblySelection = selectedOption.value;
  this.getMountPosition(this.shaftTypeSelection, this.gearOrientationSelection, this.Size, this.configurationData.Assembly);
  // if(this.dutyCycle=="yes"){
    this.getCoolingFan(this.assemblySelection, this.shaftTypeSelection, this.gearOrientationSelection, this.Size);
  // }
    
  this.resetDependentDropdowns(['inputMountingPosition']);
  this.openMountingPosition();
}
    }
  });
}

displayElement(ele:string){

  const element = document.getElementById(ele);
  const heading = document.getElementById("heading");

  if (element) {
    element.style.display = "block";
    if(heading){
      heading.style.display = "block";
    }
  }
}












openFanDialog() {
  const dialogRef = this.dialog.open(FandialogComponent, {
  });

  if(this.configurationData.inputType=="SE"){
    this.displayElement("SE");
	
  }else if(this.configurationData.inputType=="DE"){
    this.displayElement("DE");
	
  } else if(this.configurationData.inputType=="SA"){
    this.displayElement("SA");
	
  }else if(this.configurationData.inputType=="DA"){
    this.displayElement("DA");
  }


  dialogRef.afterClosed().subscribe((selectedImage) => {
    debugger;
    var data=0;
    if (selectedImage) {
      const imgData = document.getElementById('inputCoolingFan') as HTMLInputElement;
      const dropdown = this.inputCoolingFanDropDown.nativeElement;
      if (imgData) {
        const targetValue = selectedImage; // The value you want to select
      
        for (let i = 0; i < dropdown.options.length; i++) {
          if (dropdown.options[i].text === targetValue) {
            this.configurationData.coolingType = dropdown.options[i].text
            dropdown.selectedIndex = i;
            data=i; // Set the dropdown's selected index to the matching option
            break; // Stop the loop once the match is found
          }
        }
      }

    }
  });

  this.reducerSelectionForm.get('inputCoolingFan')?.setValidators([]);
      this.reducerSelectionForm.get('inputCoolingFan')?.updateValueAndValidity();
}


openMountingPosition(){

  const dialogRef = this.dialog.open(HPMountingPosComponent, {
    maxHeight: '90vh', // 80% of the viewport height
    width: '600px',    // Optional: set a specific width for the dialog
  });

  if(this.configurationData.Assembly == "assembly1"){
        this.displayElement("assembly1");
  }else if(this.configurationData.Assembly == "assembly2"){
        this.displayElement("assembly2");
  }else if(this.configurationData.Assembly == "assembly3"){
        this.displayElement("assembly3");
  }else if(this.configurationData.Assembly == "assembly4"){
        this.displayElement("assembly4");
  }else if(this.configurationData.Assembly == "assembly5"){
        this.displayElement("assembly5");
  }else if(this.configurationData.Assembly == "assembly6"){
        this.displayElement("assembly6");
  }else if(this.configurationData.Assembly == "assembly7a"){
    this.displayElement("assembly7a");
}else if(this.configurationData.Assembly == "assembly8a"){
  this.displayElement("assembly8a");
}else if(this.configurationData.Assembly == "assembly9a"){
  this.displayElement("assembly9a");
}else if(this.configurationData.Assembly == "assembly0a"){
  this.displayElement("assembly0a");
}else if(this.configurationData.Assembly == "assembly7b"){
  this.displayElement("assembly7b");
}else if(this.configurationData.Assembly == "assembly8b"){
this.displayElement("assembly8b");
}else if(this.configurationData.Assembly == "assembly9b"){
this.displayElement("assembly9b");
}else if(this.configurationData.Assembly == "assembly0b"){
this.displayElement("assembly0b");
}else if(this.configurationData.Assembly == "assembly7c"){
  this.displayElement("assembly7c");
}else if(this.configurationData.Assembly == "assembly8c"){
this.displayElement("assembly8c");
}else if(this.configurationData.Assembly == "assembly9c"){
this.displayElement("assembly9c");
}else if(this.configurationData.Assembly == "assembly0c"){
this.displayElement("assembly0c");
}

  dialogRef.afterClosed().subscribe((selectedImage) => {
    debugger;
    var data=0;
    if(this.Size<120){
      debugger;
      
      const motorAdaptor = document.getElementById("inputMotorAdaptor") as HTMLInputElement
      if(motorAdaptor.disabled == true){
        motorAdaptor.disabled = false;
        this.reducerSelectionForm.get('inputMotorAdaptor')?.enable();
        this.reducerSelectionForm.get('inputMotorAdaptor')?.updateValueAndValidity();
      }
      if (selectedImage) {
        const imgData = document.getElementById('inputMountingPosition') as HTMLInputElement;
        const dropdown = this.inputMountingPositionDropDown.nativeElement;
        if (imgData) {
          const targetValue = selectedImage; // The value you want to select
        
          for (let i = 0; i < dropdown.options.length; i++) {
            if (dropdown.options[i].value === targetValue) {
              this.configurationData.MountingPosition = dropdown.options[i].value;
              this.configurationData.MountingPositionText = dropdown.options[i].text;
              dropdown.selectedIndex = i;
              data=i; // Set the dropdown's selected index to the matching option
              break; // Stop the loop once the match is found
            }
          }
        }
      }
      if(this.Size<=80){
        this.getMotorAdaptor();
      }else
      {
        this.setStatus ="no";
              const coolingFan = document.getElementById("inputCoolingFan") as HTMLInputElement
              const motorFrameSize = document.getElementById("inputMotorFrameSize") as HTMLInputElement
          this.reducerSelectionForm.get('inputMotorFrameSize')?.disable();
          this.reducerSelectionForm.get('inputMotorAdaptor')?.disable();
          motorFrameSize.value='';
          this.configurationData.MotorAdaptor = "N";
          console.log(this.configurationData);
          if(this.configurationData.inputType=="SA"){
            this.configurationData.inputType = "SE";
          }else if(this.configurationData.inputType=="DA"){
            this.configurationData.inputType="DE";
          }
          let arrMatch = [15,20,25,120];
          if(arrMatch.includes(parseInt(this.Size))){
            this.reducerSelectionForm.get('inputCoolingFan')?.disable();
          }else{
            if(coolingFan.disabled == true){
              coolingFan.disabled = false;
            }
            this.getFan();
          }
          this.resetDependentDropdowns(['inputMotorFrameSize']);
      }
      
    }else{
      const coolingFan = document.getElementById("inputCoolingFan") as HTMLInputElement
      coolingFan.disabled = true;
      this.reducerSelectionForm.get('inputCoolingFan')?.updateValueAndValidity();
      this.reducerSelectionForm.get('inputMotorAdaptor')?.setValidators([]);
      this.reducerSelectionForm.get('inputMotorFrameSize')?.setValidators([]);
      this.reducerSelectionForm.get('inputMotorAdaptor')?.updateValueAndValidity();
      this.reducerSelectionForm.get('inputMotorFrameSize')?.updateValueAndValidity();
      if (selectedImage) {
        const imgData = document.getElementById('inputMountingPosition') as HTMLInputElement;
        const dropdown = this.inputMountingPositionDropDown.nativeElement;
        if (imgData) {
          const targetValue = selectedImage; // The value you want to select
        
          for (let i = 0; i < dropdown.options.length; i++) {
            if (dropdown.options[i].value === targetValue) {
              this.configurationData.MountingPosition = dropdown.options[i].value;
              this.configurationData.MountingPositionText = dropdown.options[i].text;
              dropdown.selectedIndex = i;
              data=i; // Set the dropdown's selected index to the matching option
              break; // Stop the loop once the match is found
            }
          }
        }
  
  
      }
      const motorAdaptor = document.getElementById("inputMotorAdaptor") as HTMLInputElement
      const motorFrameSize = document.getElementById("inputMotorFrameSize") as HTMLInputElement
      
      this.configurationData.MotorAdaptor = "N";
      motorAdaptor.disabled = true;
      motorFrameSize.disabled = true;
      motorAdaptor.value='';
      motorFrameSize.value='';
      this.getFan();
    }

    
  });
  this.resetDependentDropdowns(['inputMotorAdaptor']);
}
}